// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"b2ffb92b","453":"39cf96e3"}[chunkId] + ".chunk.js";
};